import "./public-path";
import * as Vue from 'vue'
import * as VueRouter from 'vue-router'
import { createApp, App as AppInstance } from "vue";
import {
  createRouter,
  createWebHashHistory,
  Router,
  RouterHistory,
} from "vue-router";
import App from "./App.vue";
import { routes } from "./router";

import 'mdesign3/theme-chalk/src/base.scss'

import { init } from "@apaas/apaas-kit";
import "@apaas/apaas-kit/style.css";
import "./style/global.scss";

window.sessionStorage.setItem("appId", process.env.VUE_APP_APP_ID as string);
window.Vue = Vue
window.VueRouter = VueRouter
window.runEnv = process.env.VUE_APP_RUN_ENV || 'prod'

// 与基座进行数据交互
function handleMicroData(router: Router) {
  // 是否是微前端环境
  if (window.__MICRO_APP_ENVIRONMENT__) {
    // 主动获取基座下发的数据
    console.log("child-vue3 getData:", window.microApp.getData());

    // 监听基座下发的数据变化
    window.microApp.addDataListener((data: Record<string, unknown>) => {
      console.log("child-vue3 addDataListener:", data);

      // 当基座下发path时进行跳转
      if (data.path && data.path !== router.currentRoute.value.path) {
        router.push(data.path as string);
      }
    });

    // 向基座发送数据
    setTimeout(() => {
      window.microApp.dispatch({ myname: "child-vue3" });
    }, 3000);
  }
}

/**
 * 用于解决主应用和子应用都是vue-router4时相互冲突，导致点击浏览器返回按钮，路由错误的问题。
 * 当前vue-router版本：4.0.12
 */
function fixBugForVueRouter4(router: Router) {
  // 判断主应用是main-vue3，因为这个主应用是 vue-router4
  if (window.location.href.includes("/main-vue3")) {
    /**
     * 重要说明：
     * 1、这里主应用下发的基础路由为：`/main-xxx/app-vue3`，其中 `/main-xxx` 是主应用的基础路由，需要去掉，我们只取`/app-vue3`，不同项目根据实际情况调整
     *
     * 2、realBaseRoute 的值为 `/app-vue3`
     */
    const realBaseRoute = window.__MICRO_APP_BASE_ROUTE__.replace(
      /^\/main-[^/]+/g,
      ""
    );

    router.beforeEach(() => {
      if (typeof window.history.state?.current === "string") {
        window.history.state.current = window.history.state.current.replace(
          new RegExp(realBaseRoute, "g"),
          ""
        );
      }
    });

    router.afterEach(() => {
      if (typeof window.history.state === "object") {
        window.history.state.current =
          realBaseRoute + (window.history.state.current || "");
      }
    });
  }
}

function handlePageName(router: Router) {
  router.afterEach((to, from) => {
    if (to.meta?.pageName) {
      document.title = to.meta.pageName as string
    }
  })
}

let app: AppInstance | null = null;
let router: Router | null = null;
let history: RouterHistory | null = null;
// 将渲染操作放入 mount 函数
function mount() {
  // __MICRO_APP_BASE_ROUTE__ 为micro-app传入的基础路由
  history = createWebHashHistory(
    window.__MICRO_APP_BASE_ROUTE__ || process.env.BASE_URL
  );
  router = createRouter({
    history,
    routes,
  }) as Router;

  // @ts-ignore
  app = createApp(App);
  if (process.env.VUE_APP_HIDE_VUE_WARNING === "true") {
    app.config.warnHandler = () => null;
  }
  app.use(router);
  init(app as any, {
    apaasI18nBaseUrl: process.env.VUE_APP_PROXY_I18N,
    apaasApiBaseUrl: process.env.VUE_APP_PROXY_API,
    apaasEngineBaseUrl: process.env.VUE_APP_PROXY_API,
    apaasEnv: process.env.VUE_APP_RUN_ENV || 'prod',
    apaasTapprovalBaseUrl: process.env.VUE_APP_PROXY_T_APPROVAL,
  });
  app.mount("#app");
  // console.log("微应用child-vue3渲染了");

  handleMicroData(router);

  fixBugForVueRouter4(router);

  handlePageName(router);

  // window.sessionStorage.setItem('appId', (process.env.VUE_APP_APP_ID as string))
}

// 将卸载操作放入 unmount 函数
function unmount() {
  app?.unmount();
  history?.destroy();
  app = null;
  router = null;
  history = null;
  console.log("微应用child-vue3卸载了");
}

// 微前端环境下，注册mount和unmount方法
if (window.__MICRO_APP_ENVIRONMENT__) {
  // @ts-ignore
  window[`micro-app-${window.__MICRO_APP_NAME__}`] = { mount, unmount };
} else {
  mount();
}
